/**
 * Built-in Samples fieldset wrapper, shared by workspace settings.
 * Delegates instrument/volume editing to sample.js; sample_synth and synth wiring
 * own audio activation, decoding and voice lifetime.
 */

import PropTypes from "prop-types";
import Sample from "./sample";

const SampleSynth = (props) => (
  <fieldset class="output-routing-fieldset">
    <legend>
      <b>Built-in Samples</b>
    </legend>
    <label>
      Use Internal Sounds
      <input
        name="output_sample"
        type="checkbox"
        checked={!!props.settings.output_sample}
        onChange={(e) => {
          props.onChange(e.target.name, e.target.checked);
          sessionStorage.setItem(e.target.name, e.target.checked);
        }}
      />
    </label>
    {props.settings.output_sample && <Sample {...props} onVolumeChange={props.onVolumeChange} />}
    {/* Fixed velocity hard-coded to 72; midi_velocity UI hidden */}
    {props.showActivateAudioContext && props.activateAudioContext && (
      <div class="settings-form__reload-row settings-form__checkbox-row--sm">
        <button
          type="button"
          class="preset-action-btn settings-form__activate-audio-btn"
          onClick={() => void props.activateAudioContext()}
        >
          Activate Audio Context
        </button>
      </div>
    )}
  </fieldset>
);

SampleSynth.propTypes = {
  settings: PropTypes.shape({
    output_sample: PropTypes.bool,
    output_mts: PropTypes.bool,
    output_mpe: PropTypes.bool,
  }).isRequired,
  midi: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  showActivateAudioContext: PropTypes.bool,
  activateAudioContext: PropTypes.func,
};

export default SampleSynth;
